import { v4 as uuid } from "uuid";

// Utility to get stored client ID
export function getPlayerId() {
    return localStorage.getItem('game_player_id');
}

// Utility to get or create a persistent client ID
export function getOrCreatePlayerId() {
    let playerId = getPlayerId();
    
    if (!playerId) {
        playerId = uuid();
        localStorage.setItem('game_player_id', playerId);
    }
    
    return playerId;
}
